
import React, { useState } from 'react';
import { dbService } from '../services/dbService.ts';

const ProfessionalRewardsView = ({ user }: any) => {
  const profile = dbService.getProfessionalProfile(user.id);
  const categories = [
    { 
      name: "Professional Development", 
      icon: "fa-graduation-cap", 
      items: [
        { id: 'masterclass', title: 'Masterclass Sub', points: 1000, desc: "1 Year Annual Membership" },
        { id: 'cert', title: 'AWS/GCP Cert Voucher', points: 1500, desc: "Standard Exam Fee" }
      ] 
    },
    { 
      name: "Charity & Impact", 
      icon: "fa-hand-holding-heart", 
      items: [
        { id: 'charity_100', title: 'Donate $100', points: 500, desc: "To Doctors Without Borders" },
        { id: 'planting', title: 'Plant 100 Trees', points: 300, desc: "Eco-Restoration Fund" }
      ] 
    },
    { 
      name: "Personal Spending", 
      icon: "fa-coffee", 
      items: [
        { id: 'starbucks', title: '$50 Gift Card', points: 400, desc: "Starbucks / Amazon / Uber" },
        { id: 'tech', title: 'Noise-Cancelling Headphones', points: 5000, desc: "Sony WH-1000XM5" }
      ] 
    }
  ];

  return (
    <div className="p-12 lg:p-20 bg-slate-50/30 dark:bg-slate-950/30 min-h-screen transition-colors duration-500 font-sans">
        <header className="mb-12 flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8">
          <div>
            <span className="text-[10px] font-black uppercase tracking-[0.4em] text-indigo-600 dark:text-indigo-400 mb-3 block">Value Accrual Hub</span>
            <h1 className="text-6xl font-black text-blue-950 dark:text-white tracking-tighter leading-none">Marketplace.</h1>
          </div>
          <div className="p-8 bg-blue-950 dark:bg-indigo-600 text-white rounded-[2.5rem] flex items-center gap-6 shadow-4xl relative overflow-hidden">
             <div className="absolute top-0 right-0 p-4 opacity-10 text-6xl rotate-12"><i className="fas fa-coins"></i></div>
             <i className="fas fa-coins text-amber-400 text-4xl relative z-10"></i>
             <div className="relative z-10">
                <p className="text-[9px] font-black uppercase tracking-widest opacity-60 mb-1">Synergy Balance</p>
                <p className="text-4xl font-black">{profile?.points || 0}</p>
             </div>
          </div>
        </header>

        <div className="space-y-16">
           {categories.map((cat, i) => (
             <section key={i} className="animate-in fade-in slide-in-from-bottom-4" style={{ animationDelay: `${i * 100}ms` }}>
                <div className="flex items-center gap-4 mb-8">
                   <div className="w-12 h-12 bg-white dark:bg-slate-900 rounded-2xl shadow-xl flex items-center justify-center text-indigo-600 dark:text-indigo-400 border border-slate-50 dark:border-slate-800"><i className={`fas ${cat.icon} text-lg`}></i></div>
                   <h2 className="text-2xl font-black text-blue-950 dark:text-white tracking-tight">{cat.name}</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                   {cat.items.map(item => (
                     <div key={item.id} className="bg-white dark:bg-slate-900 p-10 rounded-[3.5rem] border border-slate-100 dark:border-slate-800 shadow-2xl flex flex-col group hover:border-indigo-500/30 transition-all hover:-translate-y-1">
                        <h3 className="text-xl font-black text-blue-950 dark:text-white mb-2 group-hover:text-indigo-600 transition-colors">{item.title}</h3>
                        <p className="text-xs text-slate-400 dark:text-slate-500 font-bold mb-10 leading-relaxed">{item.desc}</p>
                        <div className="mt-auto flex items-center justify-between pt-6 border-t border-slate-50 dark:border-slate-800">
                           <div className="flex flex-col">
                              <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1">Required</span>
                              <span className="text-lg font-black text-indigo-600 dark:text-indigo-400">{item.points.toLocaleString()} PTS</span>
                           </div>
                           <button 
                             disabled 
                             className="px-8 py-4 bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 rounded-2xl text-[10px] font-black uppercase tracking-widest cursor-not-allowed border border-slate-100 dark:border-slate-700"
                           >
                             Redeem
                           </button>
                        </div>
                     </div>
                   ))}
                </div>
             </section>
           ))}
        </div>
    </div>
  );
};

export default ProfessionalRewardsView;
